import { render, staticRenderFns } from "./VehicleServiceFiles.vue?vue&type=template&id=0bd050bc"
import script from "./VehicleServiceFiles.vue?vue&type=script&lang=js"
export * from "./VehicleServiceFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports